import React, { useContext } from "react";
import { CourseContext } from "./CourseContext";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { useAppTranslation } from "./TranslationContext";
import { useAuth } from '../context/AuthContext';

export const CourseCards = () => {
  // перевод
    const { t } = useAppTranslation();
    const { handleLang } = useAuth();

  const courses = useContext(CourseContext);

  return (
    <div className="container">
      <h2 className="card__title">{t('courseCardsTitle')}</h2>
      <div className="cards">
        {courses.map((course, index) => (
          <Link className="card" to={`/course/${course.id}`} key={course.id}>
            <div className={`card_bgc bg${(index % 6) + 1}`}>
              {/* <p className="tag">{course.category}</p> */}
              <img className="card__image" src={course.img1_uz} alt={course.title_uz} />
              <div className="card_contents">
                <p className="card__name">{handleLang(course.title_uz, course.title_ru, course.title_en)}</p>
                <p className="date">{course.duration + handleLang(" oy", " месяцев", " month")}</p>
                <p className="hidden_content">{handleLang(course.desc_uz, course.desc_ru, course.desc_en)}</p>
              </div>
              <span className="card_contents-bg"></span>
              {/* <img className="card__image" src={course.img_uz} alt={course.title_uz} /> */}
              
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};



